import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postRequest, getRequest } from "services/api";
import { getPostLoginRedirect } from "utils/authRedirect";

// Membuat konteks untuk autentikasi
export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fungsi untuk login
  const login = async (credentials) => {
    try {
      const response = await postRequest("/login", credentials);

      localStorage.setItem("token", response.token);
      setUser(response.data);
      setLoading(false); // Set loading ke false setelah login berhasil
      navigate(getPostLoginRedirect(response.data));
    } catch (error) {
      console.error("Login error:", error);
      throw error;
      // alert('Login failed');
    }
  };

  // Fungsi untuk logout
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setLoading(false); // Set loading false ketika logout
    navigate("/login");
  };

  const getUserVold = async () => {
    try {
      const response = await getRequest("/me");
      setUser(response.data);
    } catch (error) {
      console.error("Get user error:", error);
      logout(); // Logout jika gagal mendapatkan user
    } finally {
      setLoading(false); // Set loading ke false setelah data user diambil
    }
  };

  const getUserV2 = async () => {
    try {
      const cachedUser = localStorage.getItem("user");
      if (cachedUser) {
        setUser(JSON.parse(cachedUser));
        return;
      }
  
      const response = await getRequest("/me");
      setUser(response.data);
      localStorage.setItem("user", JSON.stringify(response.data)); // Simpan di cache
    } catch (error) {
      console.error("Get user error:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const getUser = async () => {
    try {
      const cachedUser = localStorage.getItem("user");
      if (cachedUser) {
        const parsedUser = JSON.parse(cachedUser);
        setUser(parsedUser);  // Menetapkan user dari localStorage
        await compareUserWithServer(parsedUser); // Bandingkan dengan server
        return;
      }
  
      const response = await getRequest("/me");
      setUser(response.data);
      localStorage.setItem("user", JSON.stringify(response.data)); // Simpan di localStorage
    } catch (error) {
      console.error("Get user error:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk membandingkan data user di localStorage dengan data dari server
  const compareUserWithServer = async (localUser) => {
    try {
      const response = await getRequest("/me"); // Ambil data terbaru dari server
      const serverUser = response.data;
      
      // Bandingkan data user di localStorage dan server
      if (JSON.stringify(localUser) !== JSON.stringify(serverUser)) {
        // Jika ada perbedaan, perbarui localStorage dengan data terbaru
        console.log("Data berbeda, memperbarui localStorage...");
        localStorage.setItem("user", JSON.stringify(serverUser));
        setUser(serverUser);  // Perbarui state 'user' dengan data terbaru dari server
      } else {
        console.log("Data sudah cocok.");
      }
    } catch (error) {
      console.error("Error saat membandingkan user:", error);
    }
  };
  

  //   Mengecek token saat aplikasi pertama kali di-mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      getUser();
    } else {
      setLoading(false); // Set loading ke false jika tidak ada token
    }
  }, []);

  // v1
  //   useEffect(() => {
  //     let isMounted = true;
  //     const token = localStorage.getItem("token");
  //     if (token && isMounted) {
  //       getUser();
  //     } else {
  //       setLoading(false);
  //     }
  //     return () => {
  //       isMounted = false; // Cleanup untuk memastikan tidak ada panggilan berlebih
  //     };
  //   }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
